export default {
  index: {
    postInfo: 'order/customProductCreate',
  }

}
